module.exports = __webpack_public_path__ + "static/img/mailbox.885bfb1a.png";